import { Link } from "react-router-dom";
import { Logo } from "../common/ui";

const HERO_IMG =
  "https://images.unsplash.com/photo-1545505567-7327366a634d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxmaXJld29ya3MlMjBuaWdodCUyMHNreXxlbnwwfHx8fDE3ODM2NDA4NTV8MA&ixlib=rb-4.1.0&q=85";

/* Split-screen auth shell: brand imagery on the left, form on the right. */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen cf-bg cf-grain">
      <div className="relative z-10 grid lg:grid-cols-2 min-h-screen">
        {/* Brand panel */}
        <div className="relative hidden lg:block overflow-hidden">
          <img src={HERO_IMG} alt="Fireworks" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-ink" />
          <div className="relative h-full flex flex-col justify-between p-12">
            <Logo />
            <div className="max-w-md">
              <p className="text-xs tracking-[0.3em] uppercase font-bold cf-gold-text mb-4">Clacton-on-Sea, Essex</p>
              <h2 className="font-playfair text-4xl leading-tight text-white">Reserve online.<br />Collect in-store.</h2>
              <p className="mt-4 text-white/70">Create an account to reserve premium fireworks, track your collection status, and save your favourites.</p>
            </div>
          </div>
        </div>

        {/* Form panel */}
        <div className="flex flex-col justify-center px-5 sm:px-10 lg:px-16 py-10">
          <div className="w-full max-w-md mx-auto">
            <div className="lg:hidden mb-8">
              <Logo />
            </div>
            <h1 className="font-playfair text-3xl text-white">{title}</h1>
            {subtitle && <p className="mt-2 text-muted-foreground">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
            <p className="mt-10 text-center text-xs text-muted-foreground">
              <Link to="/" className="hover:text-white">← Back to Clacton Fireworks</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
